import React, { useState, useEffect } from "react";
import validate from "./validate";
import { ComboBox } from "ui-core-dashboard";
import DatePicker from "components/Common/DatePicker";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { reduxForm, Field, initialize, change } from "redux-form";
import { withTranslation } from "react-i18next";
import moment from "moment";
import baseService from "services/BaseService";
import Loader from "../../Loader";
import "./styles.scss";
import { is } from "immutable";

const mapStateToProps = (state, ownProps) => ({
    // accountNumbers: state.customer.billingCards,
});

const mapDispatchToProps = {};

function BillingFiltersBlock(props) {
    const { t, pApartId, tabKey, initialize, acc } = props;
    const [currentAccount, setCurrentAccount] = useState(null);
    // console.log(`currentAccount`, currentAccount);
    // const disabled = !accountNumbers || accountNumbers && accountNumbers.length === (0 || 1);
    const [disabled, setDisabled] = useState(true);

    const [accountNumbers, setAccountNumbers] = useState([]);
    const [loading, setLoading] = useState(false);

    function transformResponse(data) {
        return data.map(item => ({
            // value: parseInt(item.acc, 10),
            value: `${item.uid}`,
            label: `${item.acc} ${item.fio}`,
        }));
    }

    const getAccountNumbers = () => {
        setLoading(true);
        const params = {
            data: { page: 1, limit: 1000, start: 0, query: "", destroyOnUnmount: true, pApartId: pApartId },
        };

        baseService
            .get("billing_cards", params)
            .then(response => {
                if (response.success && response.result) {
                    const transformedResult = transformResponse(response.result);
                    if (transformedResult.length !== 0) {
                        setDisabled(false);
                    }
                    setAccountNumbers(transformedResult);
                }
            })
            .catch(error => {
                console.error("getAccounts catch error", error);
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    };

    useEffect(() => {
        setDefaultFilterParams();
    }, [tabKey, pApartId, accountNumbers]);

    useEffect(() => {
        getAccountNumbers();
    }, []);

    const setDefaultFilterParams = () => {
        if (accountNumbers && accountNumbers.length) {
            const acc = accountNumbers[0].value;
            // console.log(`acc`, acc);
            setCurrentAccount(acc);
            const nowDate = new Date();

            switch (tabKey) {
                case "billing_finstatus":
                    initialize({
                        acc,
                        dateBegin: moment(nowDate).startOf("month"),
                        dateEnd: moment(nowDate).endOf("month"),
                    });
                    break;
                case "billing_payments":
                    initialize({
                        acc,
                        dateBegin: moment(nowDate)
                            .add(-1, "month")
                            .startOf("month"),
                        dateEnd: moment(nowDate).endOf("month"),
                    });
                    break;
                case "billing_recalculations":
                    initialize({
                        acc,
                        dateBegin: moment(nowDate).add(-1, "year"),
                        dateEnd: nowDate,
                    });
                    break;
            }
        } else {
            props.change("acc", null);
            props.change("dateBegin", null);
            props.change("dateEnd", null);
        }
    };

    const handleChange = value => {
        setCurrentAccount(value);
    };

    return (
        <>
            <div className={"billing-filter-wrapper ordering-component-ui-core-wrapper"}>
                {loading && <Loader />}
                <div className="inline-wrapper">
                    <Field
                        component={ComboBox}
                        name="acc"
                        placeholder={t("dontSelect")}
                        noResultsText={t("noItems")}
                        label={t("fullNumber")}
                        searchable={false}
                        clearable={false}
                        options={accountNumbers}
                        value={currentAccount}
                        disabled={disabled}
                        onChange={handleChange}
                    />
                </div>

                <div className="between-fields-wrapper">
                    <Field
                        name="dateBegin"
                        label={t("filter.periodFrom")}
                        placeholder="01/01/2000"
                        component={DatePicker}
                        popperClassName="billing-date-from"
                        onlyDate={true}
                    />
                    <Field
                        name="dateEnd"
                        label={t("filter.periodTo")}
                        placeholder="01/01/2000"
                        component={DatePicker}
                        popperClassName="billing-date-to"
                        onlyDate={true}
                    />
                </div>
            </div>
        </>
    );
}

export default withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(reduxForm({ validate, enableReinitialize: true })(BillingFiltersBlock))
);
